import { render, staticRenderFns } from "./Skill.vue?vue&type=template&id=3c8b8c1e&scoped=true"
import script from "./Skill.vue?vue&type=script&lang=js"
export * from "./Skill.vue?vue&type=script&lang=js"
import style0 from "./Skill.vue?vue&type=style&index=0&id=3c8b8c1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8b8c1e",
  null
  
)

export default component.exports